function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { useTestId } from '@wolffun/testable-id';
import styles from './styles.module.scss';
const STEP = 10;

const QuantityBattle = ({
  onChanged,
  minBattle,
  maxBattle
}) => {
  const {
    generateTestIdProps
  } = useTestId();
  const minValue = minBattle || 0;
  const maxValue = maxBattle || 0;
  const [currentValue, setCurrentValue] = React.useState(minValue);
  React.useEffect(() => {
    onChanged === null || onChanged === void 0 ? void 0 : onChanged(currentValue);
  }, [currentValue, onChanged]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("button", {
    disabled: currentValue <= minValue,
    onClick: () => {
      if (currentValue > 0) {
        setCurrentValue(pre => Math.max(minValue, pre - STEP));
      }
    },
    className: styles.btn
  }, "-"), /*#__PURE__*/React.createElement("input", _extends({
    value: String(currentValue),
    onChange: e => {
      const input = parseInt(e.target.value) || 0;
      setCurrentValue(Math.abs(input));
    },
    type: "number",
    className: styles.input
  }, generateTestIdProps('input-battle-for-rent'))), /*#__PURE__*/React.createElement("button", {
    disabled: currentValue >= maxValue,
    onClick: () => setCurrentValue(pre => Math.min(maxValue, pre + STEP)),
    className: styles.btn
  }, "+"));
};

export default QuantityBattle;